export default "/images/AlertMarketing.jpg?049fca745319c0674ca14818cf73611a";